import React from 'react';
import PropTypes from 'prop-types';

import Loading from '../../Loading';
import * as styles from './LoadingRow.scss';

/**
 * LoadingRow Component for Table
 * @function LoadingRow
 * @param {Object} props
 * @return {ReactElement}
 */
const LoadingRow = props => {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <div style={{ textAlign: 'center', width: '100%' }}>
        <Loading spinnerClassName={styles.loadingRowSpinner} rectClassName={styles.loadingRowRect} />
      </div>
    </div>
  );
};

LoadingRow.propTypes = {
  className: PropTypes.string.isRequired,
  style: PropTypes.shape({
    height: PropTypes.number,
    left: PropTypes.number,
    overflow: PropTypes.string,
    paddingRight: PropTypes.number,
    position: PropTypes.string,
    top: PropTypes.number,
    width: PropTypes.number,
  }).isRequired,
};

export default LoadingRow;
